import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import * as $ from 'jquery';

@Component({
  templateUrl: './admin-layout.component.html',
  styleUrls: [
    '../../../assets/css/admin/fontawesome/scss/font-awesome.scss',
    '../../../assets/css/admin/select2CalculadoraCupratheme/src/select2-calculadora-cupra-theme.scss',
    '../../../assets/css/admin/admin.scss'
    ],
  encapsulation: ViewEncapsulation.None
})

export class AdminLayoutComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
    $('body').addClass('admin-layout');
  }

}
